


































































































import Vue from 'vue';
import Table from '@/components/table/Table.vue';
import CreateInlinePixelForm from '@/components/campaign/targets/retarget/inlinePixel/CreateInlinePixelForm.vue';
import { AudienceStatistics, Pixel } from '@/types/audience/audience';
import filterParams from '@/components/table/utils/filterParameters';
import { mapGetters } from 'vuex';

export default Vue.extend({
  name: 'Audiences',
  components: { Table, CreateInlinePixelForm },
  created() {
    const params = filterParams.getUrlFilter(this.$route.query['filter']) || {};
    this.$store.commit('changeTitle', this.$t('pages.audiences.title'));
    this.getAudience(params);
  },
  computed: {
    ...mapGetters({
      audiences: 'audience/getAudiencesList',
      paginationData: 'audience/getAudiencePaginationData',
    }),
    getCreateAudienceRoute() {
      return '/audiences/create';
    },
  },
  methods: {
    async getAudience(data) {
      let columns: Array<string> = [];
      this.loadData = true;
      this.columns.map((item, index) => {
        if (data[item.field]) {
          this.columns[index].filterValue = data[item.field];
        } else {
          this.columns[index].filterValue = null;
        }
      });
      if (data.sort) {
        this.sort = data.sort;
      }

      columns = this.columns.map(col => {
        return col.field;
      });

      await this.$store.dispatch('audience/audiencesList', {
        searchData: data,
        columns,
      });
      filterParams.saveFilter();
      this.loadData = false;
    },
    editAudience(audience) {
      this.$router.push('/audiences/update/' + audience.id);
    },
    deleteAudience(audience: AudienceStatistics) {
      this.$confirm({
        title: this.$t('pages.audiences.popup.title'),
        content: this.$t('pages.audiences.popup.message'),
        cancelText: this.$t('body.popup.buttons.no'),
        okText: this.$t('body.popup.buttons.yes'),
      }).then(() => {
        if (!audience.id) {
          return;
        }
        this.deleteConfirmed(audience.id);
      });
    },
    async deleteConfirmed(id: number) {
      await this.$store.dispatch('audience/deleteAudience', { id });
    },
    copyPixelCode(audience) {
      if (audience.pixels?.length) {
        this.copyToClipboard = audience.pixels[0].public_key;
      }
    },
    showPixelCode(audience) {
      if (audience.pixels?.length) {
        this.pixel = audience.pixels[0];
        this.modal = true;
      }
    },
    closeModal() {
      this.modal = false;
    },
  },
  data() {
    return {
      columns: [
        {
          name: this.$t('pages.audiences.table.header.id'),
          field: 'id',
          filterValue: null,
        },
        {
          name: this.$t('pages.audiences.table.header.name'),
          field: 'name',
          filterValue: null,
        },
        {
          name: this.$t('pages.audiences.table.header.scope'),
          field: 'cover',
          filterValue: null,
        },
        {
          name: this.$t('pages.audiences.table.header.size'),
          field: 'size',
          filterValue: null,
        },
        { name: '', field: 'buttons', filterValue: null, useSort: false },
      ],
      sort: null,
      loadData: false,
      modal: false,
      pixel: {} as Pixel | null,
      copyToClipboard: '',
    };
  },
});
